module.exports = __webpack_public_path__ + "media/ScaleAQ - ny deltaker i TERRAVERA Business Program.d7eae771.mp4";